/* Product Page Create */
$(document).on("pageshow", ".template-product[data-role=page]", function(event, data) {
 var page = jQuery(this);
 startSlider(event, data, page);
if (typeof yotpo != "undefined") {
  yotpo.initialized = false;
yotpo.initWidgets(); 
}
Shopify.AjaxifyCart.init();  
  
});


// activate product image slider on product page
jQuery(document).on('pagebeforeshow', '.template-product[data-role=page]', function () {
 helpaccordion2();  
});



jQuery(document).on('pagehide', '.template-product[data-role=page]', function () {
this.remove(); 
});

$(document).on("pagecreate", ".template-product[data-role=page]", function(event, data) {
jQuery(function() {
  var page = jQuery(this); 
  page.find('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
  });
});  
});






function startSlider(event, data, page) {

var container = page.find('.swiper-container');
var pagination = container.find('.swiper-pagination');
  if(container.length) {
     var swiper = new Swiper((container), {         
                effect: 'slide', 
        speed: 400,
                zoom: true,
     autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }         
            });  
  }
}


function helpaccordion2() {
var acc = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function(){
        this.classList.toggle("active");
        this.nextElementSibling.classList.toggle("show");
  }
} 
}





 